/*
  Blocage du menu contextuel (clic droit), demande par Tristan le 2026-09-07.

  A savoir : cela ne protege pas le code source. La page est telechargee
  en entier par le navigateur avant d'etre affichee, et reste accessible
  par F12, Ctrl+U, Ctrl+Maj+I, le menu du navigateur ou view-source:.

  Les champs de saisie sont volontairement exclus : sans cela, le
  copier/coller et le correcteur orthographique cesseraient de fonctionner
  dans le formulaire de contact et dans le champ du code promo.
*/
document.addEventListener('contextmenu', function (e) {
  var cible = e.target;
  if (cible && cible.closest && cible.closest('input, textarea, select, [contenteditable="true"]')) {
    return;
  }
  e.preventDefault();
});
